module.exports = {
  siteTitle: "Love Song Getaway",
  phone: "+1 (888) 781-8687",
  showPhone: false,
  phoneDashed: "1-888-781-8687",
  email: "customercare@everlastingtours.com",
  officeHours: "Mon-Fri 9-5 PST",
  doubleOccupancyDisclaimer:
    "* Prices listed are per person (based on double occupancy).",
  doubleOccupancyDisclaimerNoMonthly:
    "* Prices listed are per person (based on double occupancy) and do not include the $300 pp taxes & fees.",
  urls: {
    facebook: "https://www.facebook.com/lovesonggetaway",
    facebookApp: "fb://profile/138880536123760",
    instagram: "https://www.instagram.com/lovesonggetaway/",
    instagramApp: "instagram://user?username=lovesonggetaway",
    twitter: "https://twitter.com/lovesonggetaway",
    foundation: "http://www.lovesongfoundation.com",
    passport: "https://travel.state.gov/content/passports/en/passports.html",
    insuranceReferral: "http://www.travelguard.com/agentlink.asp?ta_arc=215985",
  },
};



// WEBPACK FOOTER //
// ./lib/config/info.js